(() => {
  document.addEventListener('DOMContentLoaded', function () {
    const sections = document.querySelectorAll('[data-section-type="blog-with-tabs"]');
    sections.forEach(section => {
      initTabsSection(section);
    });
  });

  function initTabsSection(section) {
    if (!section || !(section instanceof Element)) {
      return;
    }

    const tabsWrapper = section.querySelector('[data-tabs-wrapper]');
    const itemsWrapper = section.querySelector('[data-items-wrapper]');
    const items = section.querySelectorAll('[data-tab-item]');
    
    if (!tabsWrapper || !itemsWrapper || items.length === 0) {
      return;
    }

    initSwiper(itemsWrapper, section);

    const tabNames = new Set();
    items.forEach(item => {
      const tabName = item.dataset.tabName;
      if (tabName) {
        tabNames.add(tabName);
      }
    });

    const uniqueTabs = Array.from(tabNames);
    if (uniqueTabs.length > 0) {
      uniqueTabs.forEach((tabName, index) => {
        const tab = document.createElement('div');
        tab.className = 'blog-with-tabs__tab body-small button button--secondary';
        tab.dataset.tabName = tabName;
        tab.innerHTML = `<span>${formatTabName(tabName)}</span>`;

        tab.addEventListener('click', function () {
          handleTabClick(this, tabsWrapper, items);
        });

        tabsWrapper.appendChild(tab);
      });

      showAllItems(items);
    }
  }

  function handleTabClick(clickedTab, tabsWrapper, items) {
    if (!clickedTab || !tabsWrapper || !items) {
      return;
    }

    const section = clickedTab.closest('[data-section-type="blog-with-tabs"]');
    const isFirstClick = !section.dataset.tabsActivated;

    if (isFirstClick) {
      section.dataset.tabsActivated = 'true';
      items.forEach(item => {
        if (item && item.style) {
          item.style.display = 'none';
        }
      });
    }

    tabsWrapper.querySelectorAll('[data-tab-name]').forEach(tab => {
      if (tab && tab.classList) {
        tab.classList.remove('button--tertiary');
        tab.classList.add('button--secondary');
      }
    });

    if (clickedTab.classList) {
      clickedTab.classList.remove('button--secondary');
      clickedTab.classList.add('button--tertiary');
    }

    const activeTabName = clickedTab.dataset?.tabName;
    if (activeTabName) {
      showTabItems(activeTabName, items);

      const swiperContainer = section.querySelector('.swiper');
      if (swiperContainer && swiperContainer.swiper) {
        swiperContainer.swiper.slideTo(0);
      }
    }
  }

  function showTabItems(tabName, items) {
    if (!items) {
      return;
    }

    items.forEach(item => {
      if (item && item.style) {
        item.style.display = 'none';
      }
    });

    const visibleItems = [];
    items.forEach(item => {
      if (item && item.dataset && item.dataset.tabName === tabName) {
        item.style.display = 'block';
        visibleItems.push(item);
      }
    });
  }

  function showAllItems(items) {
    if (!items) {
      return;
    }

    items.forEach(item => {
      if (item && item.style) {
        item.style.display = 'block';
      }
    });
  }

  function initSwiper(itemsWrapper, section) {
    if (!itemsWrapper || !(itemsWrapper instanceof Element)) {
      return;
    }

    try {
      const slidesPerView = section.dataset.slidesPerView || 3.4;
      const slidesPerViewMobile = section.dataset.slidesPerViewMobile || 2;
      const spaceBetween = section.dataset.spaceBetween || 8;
      const pagination = section.querySelector('.blog-with-tabs__pagination .swiper-pagination');

      const swiper = new Swiper('.blog-with-tabs .swiper', {
        slidesPerView: parseFloat(slidesPerViewMobile),
        slidePerGroup: 1,
        spaceBetween: 6,
        pagination: {
          el: pagination,
          clickable: true,
        },
        breakpoints: {
          576: {
            slidesPerView: parseFloat(slidesPerViewMobile),
            spaceBetween: parseInt(spaceBetween)
          },
          750: {
            slidesPerView: parseFloat(slidesPerViewMobile) * 2,
            spaceBetween: parseInt(spaceBetween)
          },
          990: {
            slidesPerView: parseFloat(slidesPerView),
            spaceBetween: parseInt(spaceBetween)
          },
          1200: {
            slidesPerView: parseFloat(slidesPerView),
            spaceBetween: parseInt(spaceBetween)
          }
        }
      });

      const updateGradientVisibility = () => {
        const progress = swiper.progress;
        const isAtEnd = progress >= 0.99 || swiper.isEnd;
        const isAtBeginning = progress <= 0.01 || swiper.isBeginning;
        
        section.style.setProperty('--show-left-gradient', isAtBeginning ? '0' : '1');
        section.style.setProperty('--show-right-gradient', isAtEnd ? '0' : '1');
      };

      swiper.on('slideChange', updateGradientVisibility);
      swiper.on('slideChangeTransitionEnd', updateGradientVisibility);
      swiper.on('touchEnd', updateGradientVisibility);
      
      window.addEventListener('resize', () => {
        setTimeout(updateGradientVisibility, 100);
      });
      
      updateGradientVisibility();

    } catch (error) {
      console.error('Error creating Swiper:', error);
    }
  }

  function formatTabName(tabName) {
    return tabName
      .replace(/-/g, ' ')
      .replace(/\b\w/g, l => l.toUpperCase());
  }

  document.addEventListener('shopify:section:load', function(event) {
    const section = event.target;
    if (section && section.dataset && section.dataset.sectionType === 'blog-with-tabs') {
      initTabsSection(section);
    }
  });
})();